<mat-sidenav-container class="example-container">
  <mat-sidenav #sidenav mode="side"
    class="sidenav-padding">
    <br>

      Workflow Actions

      <br>

        <button mat-button
          [disabled]="userRole == 'Viewer'"
          color="primary"
          (click)="createNewDocReview()">
          New Workflow Request
        </button>

        <br>
          <mat-divider></mat-divider>

          <button mat-button
            color="primary"
            (click)="saveDocReviewListAsCSV()">
            CSV
          </button>

          <br>

            <button mat-button
              color="primary"
              (click)="saveDocReviewListAsExcel()">
              Download as Excel
            </button>

            <br>
              <mat-divider></mat-divider>

              <button
                mat-button
                color="primary"
                (click)="openOigExclusions()">
                OIG Exclusions
              </button>

              <br>

                <button mat-button
                  color="primary"
                  type="button"
                  (click)="openDocuSign()">
                  DocuSign
                </button>

                <br>

                  <button mat-button
                    color="primary"
                    type="button"
                    (click)="openAdobeSign()">
                    Adobe Sign
                  </button>


                  <br>
                    <br>


                    </mat-sidenav>

                    <mat-sidenav-content>

                      <mat-grid-list cols="12" rowHeight="40px">

                        <mat-grid-tile
                          [colspan]=1
                          [rowspan]= 2>
                          <!-- <div class="left-align">
                          <h2>Contracts</h2>
                        </div> -->
                      </mat-grid-tile>

                      <mat-grid-tile
                        [colspan]=9
                        [rowspan]= 2>

                        <input
                          type="text"
                          class="filter-control"
                          (input)="onSearchChange($event.target.value)"
                          placeholder="Find...">

                      </mat-grid-tile>

                      <mat-grid-tile
                        [colspan]=1
                        [rowspan]= 2>
                        @if (waitingForServer) {
                          <!-- <mat-spinner
                            diameter="50">
                          </mat-spinner> -->
                        }
                        @if (!waitingForServer) {
                          <button mat-raised-button
                            (click)="refreshAllDocuments()"
                            color="primary"
                            type="button">
                            Refresh
                          </button>
                        }
                      </mat-grid-tile>


                      <mat-grid-tile
                        [colspan]=1
                        [rowspan]= 2>
                        <!-- <div class="right-align">
                        {{docReviewList.length}} <b>Results</b>
                      </div> -->
                    </mat-grid-tile>


                    <mat-grid-tile
                      [colspan]=8
                      [rowspan]= 2>

                      <mat-button-toggle-group [(ngModel)]="selectedStatuses" (change)="userChangedStatusView($event)" multiple="true" name="fontStyle" aria-label="Font Style">
                        <mat-button-toggle value="Pending">Pending</mat-button-toggle>
                        <mat-button-toggle value="Requested">Requested</mat-button-toggle>
                        <mat-button-toggle value="In Review">In Review</mat-button-toggle>
                        <mat-button-toggle value="Approved">Approved</mat-button-toggle>
                        <mat-button-toggle value="Signatures">Signatures</mat-button-toggle>
                        <mat-button-toggle value="Finalized">Finalized</mat-button-toggle>
                        <mat-button-toggle value="Suspended">Suspended</mat-button-toggle>
                        <mat-button-toggle value="Canceled">Canceled</mat-button-toggle>
                      </mat-button-toggle-group>

                    </mat-grid-tile>


                    <mat-grid-tile
                      [colspan]=4
                      [rowspan]= 2>

                    </mat-grid-tile>


                    @if (showNameSavedView) {
                      <mat-grid-tile
                        [colspan]=4
                        [rowspan]= 2
                        >
                        <mat-form-field
                          class="full-width">
                          <input
                            matInput
                            placeholder="Name this report"
                            [(ngModel)]="nameOfSavedView"
                            name="nameOfSavedView">
                        </mat-form-field>
                      </mat-grid-tile>
                    }


                    @if (showNameSavedView) {
                      <mat-grid-tile
                        [colspan]=2
                        [rowspan]= 2
                        >
                        <div class="left-align">
                          <button mat-flat-button
                            color="primary"
                            (click)="saveNamedViewNow()">
                            Save
                          </button>
                        </div>
                      </mat-grid-tile>
                    }


                    @if (loadSavedReportVisible) {
                      <mat-grid-tile
                        [colspan]=3
                        [rowspan]= 2
                        >
                        <mat-form-field
                          class="full-width">
                          <!-- <mat-select
                            [(ngModel)]="savedViewToLoadName"
                            name="savedViewToLoadName"
                            (selectionChange)="loadUserSelectedView($event.value)">
                            @for (view of savedUserViews; track view) {
                              <mat-option
                                [value]="view">
                                {{view.savedViewName}}
                              </mat-option>
                            }
                          </mat-select> -->
                        </mat-form-field>
                      </mat-grid-tile>
                    }


                    @if (customizeColumnsUi) {
                      <mat-grid-tile
                        [colspan]=6
                        [rowspan]= 2
                        >
                        @if (customizeColumnsUi) {
                          <br>
                          }
                          @if (customizeColumnsUi) {
                            <br>
                            }
                            <!-- <mat-form-field >
                              <mat-select
                                placeholder="Columns"
                                [(ngModel)]="selectedCols"
                                multiple
                                (openedChange)="selectionChanged($event.value)"
                                (selectionChange)="selectionChanged($event.value)">
                                @for (column of columnSelectList; track column) {
                                  <mat-option
                                    [value]="column.value">{{column.viewValue}}
                                  </mat-option>
                                }
                              </mat-select>
                            </mat-form-field> -->
                          </mat-grid-tile>
                        }

                      </mat-grid-list>


                      <ag-grid-angular
                        style="width: 100%; height: 800px;"
                        class="ag-theme-balham"
                        
                        [rowData]="workflowList"
                        [columnDefs]="selectedCols"
                        (gridReady)="onGridReady($event)"
                        (cellClicked)='onCellClicked($event)'
                        (columnMoved)="onColumnMoved($event)"
                        >
                      </ag-grid-angular>




                    </mat-sidenav-content>
                  </mat-sidenav-container>

